import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getVideoMetaData } from 'api/actions/avUser/avUser.actions';
import { VideoMetaData } from 'api/actions/avUser/avUser.types';
import { VideoStreamUrlValidatorOptions } from './videoStreamUrl.validator.types';

const MIN_DURATION_SECONDS = 300;

export const videoStreamUrl = ({ client, eventId }: VideoStreamUrlValidatorOptions) => async (value: string) => {
  if (!value || !eventId) {
    return undefined;
  }

  const { payload, error } = await client.query<VideoMetaData>(getVideoMetaData({ eventId, videoUrl: value }));

  if (error || !payload) {
    return <FormattedMessage id="av_user.file_uploadstream.helper_Text" />;
  }

  if (payload.isReadyToDownload === false) {
    return payload.liveStreamReason || <FormattedMessage id="av_user.file_uploadstream.unsupported_video" />;
  }

  if (payload.durationInSeconds <= MIN_DURATION_SECONDS) {
    return <FormattedMessage id="av_user.file_uploadstream.duration_validation" />;
  }

  return undefined;
};
